import React from 'react'
import { Modal, Button } from '@/shared/ui'

export type SaveFeedbackProps = {
  open: boolean
  onClose: () => void
  title?: string
  description?: string
  variant?: 'success'|'error'|'info'
}

export default function SaveFeedbackModal({ open, onClose, title='Sucesso', description='A operação foi concluída com êxito.', variant='success' }: SaveFeedbackProps){
  const icon = (
    <svg viewBox="0 0 24 24" className={['h-12 w-12', variantColor(variant)].join(' ')} fill="none" stroke="currentColor" strokeWidth="2">
      {variant==='success' && (<path d="M20 6L9 17l-5-5" />)}
      {variant==='error' && (<path d="M6 18L18 6M6 6l12 12" />)}
      {variant==='info' && (<circle cx="12" cy="12" r="9" />)}
    </svg>
  )
  return (
    <Modal open={open} onOpenChange={(v)=> !v && onClose()} className="p-6">
      <div className="flex flex-col items-center text-center">
        <div className="mb-2">{icon}</div>
        <div className="text-xl font-semibold">{title}</div>
        <div className="mt-1 max-w-md text-sm text-foreground/80">{description}</div>
        <Button className="mt-4" onClick={onClose}>Fechar</Button>
      </div>
    </Modal>
  )
}

function variantColor(v: 'success'|'error'|'info'){
  if (v==='success') return 'text-emerald-500'
  if (v==='error') return 'text-red-500'
  return 'text-sky-500'
}

